import { message } from "antd";
import Cookies from "js-cookie";
import moment from "moment";

export const checkObjEmpty = (obj) => {
    return !(obj && Object.keys(obj).length === 0 && obj.constructor === Object);
};

export const friendlyStringMoney = (s) => {
    if (typeof s === "string") {
        return [...s]
            .reverse()
            .join("")
            .match(/.{1,3}/g)
            .join(".")
            .split("")
            .reverse()
            .join("");
    } else {
        let numberToString = s.toString();
        return [...numberToString]
            .reverse()
            .join("")
            .match(/.{1,3}/g)
            .join(".")
            .split("")
            .reverse()
            .join("");
    }
};

export const flattenNestedObjects = (obj) => {
    return Object.assign(
        {},
        ...(function _flatten(o) {
            return [].concat(...Object.keys(o).map((k) => (typeof o[k] === Object ? _flatten(o[k]) : { [k]: o[k] })));
        })(obj)
    );
};

export const getArrayObjectName = (obj) => {
    const arr = [];
    for (const property in obj) {
        arr.push(obj[property].name);
    }
    return arr;
};
export const getArrayObjectValueByKey = (array, key) => {
    const result = [];
    array.forEach((element) => {
        result.push(element[key]);
    });
    return result;
};

export const renderSearchValues = (searching, translate) => {
    let res = [];
    for (const property in searching) {
        searching[property] && res.push(`${property}="${translate(searching[property])}"`);
    }
    return res.join(", ");
};

export const convertToCalenderData = (array) => {
    let res = array.map((obj) => {
        delete Object.assign(obj, { start: obj["from"] })["from"];
        delete Object.assign(obj, { end: obj["to"] })["to"];
        delete Object.assign(obj, { title: `${obj["name"]} - ${obj["class_id"]}` })["name"];
        return obj;
    });
    return res;
};

// get month range from first day to end day of current month
export const getMonthRange = () => {
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
    return { from: moment(startOfMonth).valueOf(), to: moment(endOfMonth).valueOf() };
};

// get week range from monday to sunday of current week
export const getWeekRange = () => {
    let from = moment().startOf("isoWeek").format("YYYY/MM/DD");
    let to = moment().endOf("isoWeek").format("YYYY/MM/DD");
    return { from: moment(from).valueOf(), to: moment(to).valueOf() };
};

// get day range from 00h00 to 00h00 next day
export const getDayRange = (setSelectedDate) => {
    let from = moment(setSelectedDate).format("YYYY/MM/DD");
    let to = moment(setSelectedDate).add(1, "days").format("YYYY/MM/DD");
    return { from: moment(from).valueOf(), to: moment(to).valueOf() };
};

// get base64 from url image
export const toDataURL = (url, callback) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
};

// sort array of obj by key value
export const sortByKeyOfValue = (array, key) => {
    return array.sort((a, b) => {
        return b[key] - a[key];
    });
};

export const updateDataAfterCreate = (value, oldValue, callback) => {
    let newData = oldValue;
    newData.unshift(value);
    callback(newData);
};

export const returnLogin = () => {
    setTimeout(() => {
        window.location.pathname = "/login";
    }, 1000);
};

export const checkValidSesson = (response) => {
    if (response.data.status === 401) {
        // Authentication failed
        message.error("Bạn chưa đăng nhập hoặc phiên đăng nhập đã hết hạn !!!");
        returnLogin();
        return true;
    }
    return false;
};

export const getQueryParams = (params) => {
    let query = "";
    if (!Cookies.get("token")) returnLogin();
    if (params?.code) query += `&code=${params?.code}`;
    if (params?.name) query += `&name=${params?.name}`;
    if (params?.status) query += `&status=${params?.status}`;
    if (params?.email) query += `&email=${params?.email}`;
    console.log("query:: ", query);
    return query
};

// empty image
const emptyImage =
    "data:image/png;base64,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";
export default emptyImage;
